(ns frontend.view.modals.curtains.pass-curtain.events
  (:require
   [clojure.string :as string]
   [frontend.utils :as fu]
   [common.localization :as loc]
   [common.entity :as entity]
   [frontend.actions.deal :as deal-actions]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.state.current-session :as session]
   [frontend.logging :as logging]
   [frontend.view.modals.email-editor.view :as email-editor-modal]
   [frontend.actions.email :as actions-email]))

(defn pass!
  [state deal close-modal!]
  (let [edits (:edit @state)
        {:keys [oppo/pass-reason-v2 oppo/pass-reason-secondary internal-comment broken-deal-expenses
                broken-deal-currency send-notification notify-to
                subject message footer save-default]}
        edits
        msg (merge {:oppo-id           (:db/id deal)
                    :pass-reason-id    pass-reason-v2
                    :secondary-pass-reason-id pass-reason-secondary
                    :status-comment    internal-comment
                    :send-notification send-notification
                    :notify-to         notify-to
                    :subject           subject
                    :message           message
                    :email-footer      footer
                    :save-default      save-default}
                   (when (and broken-deal-expenses (number? broken-deal-expenses))
                     {:broken-deal-expenses broken-deal-expenses
                      :broken-deal-currency (or broken-deal-currency
                                                (:tenant/default-currency @session/tenant))}))
        old-status (:oppo/status deal)
        ;; Write the change in advance only for a deal that the session holds.
        ;; Otherwise assoc-in makes a map with no :entity/type under the deal id.
        in-session? (contains? @session/entities (:db/id deal))
        on-success! (fn [] (close-modal!))
        on-error! (fn [e]
                    ;; revert optimistic write
                    (when in-session?
                      (swap! session/entities assoc-in [(:db/id deal) :oppo/status] old-status))
                    (logging/error "pass failed" e))]
    ;; optimistic write
    (when in-session?
      (swap! session/entities assoc-in [(:db/id deal) :oppo/status] :oppo.status/passed))
    (deal-actions/*->pass msg on-success! on-error!)))

(defn nylas-pass!
  [state {:keys [oppo close!]}]
  (let [email-targets (fu/resolve-contact-persons oppo)
        edits (:edit @state)
        {:keys [oppo/pass-reason-v2 oppo/pass-reason-secondary internal-comment broken-deal-expenses
                broken-deal-currency]}
        edits
        email-subject (loc/tr :pass-curtain/default-subject [(:oppo/name oppo)])
        message (or (:email-template/body (session/email-template-for pass-reason-v2))
                    (loc/tr :pass-reason-default-notification-template))
        message
        (if (string/includes? message "<p>")
          message
          (str "<p>"
               (->> message
                    (string/split-lines)
                    (remove empty?)
                    (string/join "</p><p><br></p><p>"))
               "<p><br>"
               (loc/tr :put-on-hold-curtain/default-footer [(:account/first-name @session/account)])
               "</p>"
               "</p>"))]
    (modals/open-modal!
     email-editor-modal/modal-key
     {:title-text (loc/tr :pass-and-notify)
      :cancel-text (loc/tr :cancel)
      :primary-button-text (loc/tr :confirm)
      :on-primary-submit! (fn [email success! failure!]
                            (let [data (merge {:oppo-id           (:db/id oppo)
                                               :status-comment    (or internal-comment "")
                                               :pass-reason-id    pass-reason-v2
                                               :secondary-pass-reason-id pass-reason-secondary
                                               :send-notification false}
                                              (when (and broken-deal-expenses
                                                         (number? broken-deal-expenses))
                                                {:broken-deal-expenses broken-deal-expenses
                                                 :broken-deal-currency (or broken-deal-currency
                                                                           (:tenant/default-currency
                                                                            @session/tenant))}))
                                  on-success! (fn [_args]
                                                (actions-email/*->send-email
                                                 email
                                                 (fn [args]
                                                   (success! args)
                                                   (close!))
                                                 failure!))
                                  on-error! (fn [_err]
                                              (logging/error "pass error!")
                                              (failure!))]
                              (deal-actions/*->pass data on-success! on-error!)))
      :related-entities #{(:db/id oppo)}
      :to (some->> email-targets
                   (map :person/universal-email-address))
      :subject email-subject
      :body message})))

(defn on-pass
  [state deal close-modal!]
  (let [edits (:edit @state)
        notify? (:send-notification edits)]
    (if (and notify?
             (session/nylas-active?))
      (nylas-pass! state
                   {:oppo   deal
                    :close! close-modal!})
      (let [{:keys [notify-to subject message footer]} edits
            contact (get @session/entities notify-to)
            email (:person/universal-email-address contact)
            tenant-name (entity/display-string @session/tenant)

            sender-email (if (some #{tenant-name} ["Teollisuussijoitus" "Tesi" "TeSi"])
                           (let [pipeline-id (:oppo/pipeline deal)
                                 pipeline (get @session/entities pipeline-id)]
                             (if (= (:pipeline/name pipeline) "Venture")
                               "venturebridge@tesi.fi"
                               "vakautus@tesi.fi"))
                           "admin@zapflow.com")
            ending-note (loc/tr :pass-curtain/email-ending-note [tenant-name])
            full-email (if (string/blank? footer)
                         message
                         (str message "\n\n" footer))
            confirm-text (if notify?
                           (loc/tr :pass-curtain/confirm-notify)
                           (loc/tr :pass-curtain/confirm-no-notify))]
        (modals/open-modal!
         confirmation-modal/modal-key
         {:body           (if notify?
                            [:div.kpi-email-template-preview
                             [:div.kpi-email-template-top
                              [:span.label (loc/tr :email/from) ":"] " "
                              [:span.email-text sender-email]]
                             [:div.kpi-email-template-top
                              [:span.label (loc/tr :email/to) ":"] " " [:span.email-text email]]
                             [:div.kpi-email-template-top.mt-3
                              [:span.label (loc/tr :sub) ":"] " " [:span.email-text subject]]

                             [:div.kpi-email-full-preview.preview.preview-textarea
                              full-email
                              "\n\n"
                              [:span.kpi-email-preview-ending-note
                               ending-note]]]
                            [:div.text-center
                             [:p confirm-text]])
          :confirm-text   (if notify?
                            (loc/tr :pass-curtain/pass-and-notify)
                            (loc/tr :confirm))
          :confirm-icon   ""
          :skip-checkbox? (not notify?)
          :checkbox-text  (when notify?
                            (loc/tr :pass-curtain/confirm-sending))
          :on-confirm     #(pass! state deal close-modal!)})))))
